import Link from "next/link";
import pinnacleLogo from "assets/icon/pinnacle-logo.svg";
import styles from "./NotFoundPage.module.scss";

export default function NotFoundPage() {
	return (
		<div className={styles.container}>
			<div className={styles["header-with-logo"]}>
				<Link href={`/en`}>
					<img src={pinnacleLogo.src} alt="Pinnacle Sports" style={{ width: "auto", height: 24 }} />
				</Link>
			</div>
			<div className={styles.content}>
				<div className={styles.title}>Sorry, we can't find the page you are looking for</div>
				<div className={styles.blurb}>Try checking the URL, reloading the page, or return to our homepage.</div>
				<div className={styles["button-box"]}>
					<Link href="/en">Return to homepage</Link>
				</div>
			</div>
		</div>
	);
}
